<div class="rating" [class.disabled]="disabled">
  <i *ngFor="let star of stars; let i = index"
     class="bi me-3"
     placement="bottom" ngbTooltip="{{star.point}}"
     [class.bi-star-fill]="i < selectedPoint" [class.bi-star]="i >= selectedPoint"
     (click)="setRating(star)">
  </i>
</div>
